import React, { forwardRef, useMemo } from 'react';
import { Box, Typography, Container } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './style';
import IKImage from '../../../../components/IKImage/IKImage';
import { HEADER_IMG_SRC_SET } from '../../const';
import { generateRandomImageUrl } from '../../../../utils/helpers';

interface HeaderProps {
  title?: string;
  children?: React.ReactNode;
  imageUrl?: string;
  imageSrcset?: any[];
  image?: any;
  wrapperClass?: string;
  contentWrapperClass?: string;
  imageWrapperClass?: string;
  titleClass?: string;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(
  (
    {
      title,
      children,
      imageUrl,
      imageSrcset = HEADER_IMG_SRC_SET,
      image,
      wrapperClass = '',
      contentWrapperClass = '',
      titleClass,
      imageWrapperClass,
    },
    ref,
  ) => {
    const currentImage = useMemo(() => generateRandomImageUrl(), []);

    const classes = useStyles(true)();

    return (
      <div ref={ref} className={cx(classes.wrapper, wrapperClass)}>
        <Box className={cx(classes.imageWrapper, imageWrapperClass)}>
          {image ? (
            <img src={image} alt={title} className={classes.img} />
          ) : (
            <IKImage
              className={classes.img}
              path={imageUrl || currentImage}
              alt={title}
              srcset={imageSrcset}
              sizes="100vw"
              draggable={false}
            />
          )}
        </Box>
        <Box className={classes.defaultBackground} />
        <Box className={cx(classes.contentWrapper, contentWrapperClass)}>
          {title && (
            <Container>
              <Typography className={cx(classes.title, titleClass)} variant="h1">
                {title}
              </Typography>
            </Container>
          )}
          {children}
        </Box>
      </div>
    );
  },
);

export default Header;
